"use client";

import { useState } from "react";

export default function MyComponent() {


  return (

      <div style={{ height: "100vh", width: "100%" }}>


        <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3922.5754284950203!2d107.53473757415284!3d10.534067763619136!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3175bdde9710d455%3A0xb77eac1cb963a0b5!2sHappy%20Stay%20Resort!5e0!3m2!1svi!2s!4v1710295341054!5m2!1svi!2s" width="600" height="450" style={{border :"0"}} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>

      </div>

  );
}

